import React from 'react';
import Locale from '../domain/Locale';
import { t, props } from 'tcomb-react';

@props({
  title: t.Str,
  locale: Locale,
  callback: t.Func,
  width: t.Str,
  children: t.ReactElement
})
export default class Confirm extends React.Component {

  scrollTop() {
    window.scrollTo(0, 0);
  }

  componentDidMount () {
    this.scrollTop();
  }

  doYes = (evt) => {
    evt.preventDefault();
    this.props.callback(true);
  }

  doNo = (evt) => {
    evt.preventDefault();
    this.props.callback(false);
  }

  render() {

    const style = {
      maxWidth: this.props.width
    };

    return (
      <div>
        <div className='overlay'></div>
        <div className='web-modal'>
          <div className='modal-body' style={style}>
            <div className='modal-header'>
              <h1>{this.props.title}</h1>
            </div>
            <div className='modal-section'>
              {this.props.children}
            </div>
            <div className='modal-footer'>
              <button onClick={this.doYes}>{this.props.locale.language_bundle().bool.TRUE}</button>
              <button className='primary' onClick={this.doNo}>{this.props.locale.language_bundle().bool.FALSE}</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Confirm.js
 **/